import React, { Component } from "react";
import { withRouter, } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import { base64ToStr  } from "../../utils/base64Util";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";

import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

registerLocale("pt_br", pt_br);
export const SolicitacaoComunicacaoMensagensList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.state = {
				criterioPesquisa: {
					solicitacao: '',
					lidas: '',
					orgao: '',
					gestor: '',
				},
				solicitacao: {
					id: '',
					numero: '',
					dataEnvioComunicacao: '',
				},
				orgaos: [],
				gestores: [],
				carregandoSolicitacao: false,
				carregandoOrgaos: false,
				carregandoGestores: false,
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarGestores = this.carregarGestores.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Lista de Usuários do Comunicado</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const idSolicitacao = this.props.match.params.id;
			const criterioPesquisa = this.state.criterioPesquisa;

			if(idSolicitacao){
				criterioPesquisa['solicitacao'] = idSolicitacao;
				this.setState((prevState) => ({ ...prevState,  criterioPesquisa, carregandoSolicitacao: true }));

				api.get(`/api/solicitacao-comunicacao/${idSolicitacao}`)
					.then(response => { 
						const solicitacao = response.data;

						this.setState((prevState) => ({ ...prevState, solicitacao, carregandoSolicitacao: false }));
						})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar a solicitação de comunicação.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
						this.setState((prevState) => ({ ...prevState, carregandoSolicitacao: false }));
					});

					this.carregarOrgaos(idSolicitacao);
					this.carregarGestores(idSolicitacao);
					this.executaPesquisaPaginada();
			}


			if (localStorage.getItem('stateParent') && 
				localStorage.getItem('stateParentUrl') && 
				localStorage.getItem('stateParentUrl') === this.props.location.pathname) {
				const stateParent = JSON.parse(base64ToStr(localStorage.getItem('stateParent')));
				localStorage.removeItem('stateParent');
				localStorage.removeItem('stateParentUrl');
				this.executarPesquisaAnterior(stateParent);
			} else if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		carregarOrgaos(solicitacao) {
			this.setState((prevState) => ({ ...prevState, carregandoOrgaos: true }));
			api.get(`/api/mensagem-gestor/${solicitacao}/orgaos`)
				.then(response => { 
					const orgaos = response.data;

					this.setState((prevState) => ({ ...prevState, orgaos, carregandoOrgaos: false }));
					})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					this.setState((prevState) => ({ ...prevState, carregandoOrgaos: false }));
				});
		}

		carregarGestores(solicitacao, orgao) {
			this.setState((prevState) => ({ ...prevState, carregandoGestores: true }));

			let url = `/api/mensagem-gestor/${solicitacao}/gestores`;
			if (orgao) {
				url += `?orgao=${orgao}`;
			}
			api.get(url)
				.then(response => { 
					const gestores = response.data;

					this.setState((prevState) => ({ ...prevState, gestores, carregandoGestores: false }));
					})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os gestores.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					this.setState((prevState) => ({ ...prevState, carregandoGestores: false }));
				});
		}

		renderForm() {
			const { criterioPesquisa, resultadoPesquisa, pesquisaExecutada, solicitacao, carregandoGestores, carregandoOrgaos } = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const { orgao, gestor, lidas } = criterioPesquisa;

			return(
				<div className="container-fluid">

					<div className="br-form">
						{ solicitacao.id &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Número:</label>
											<input value={solicitacao.numero} readOnly/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Data de envio da mensagem:</label>
											<DatePicker 
											locale="pt_br" 
											dateFormat="dd/MM/yyyy" 
											selected={solicitacao.dataEnvioComunicacao} 
											disableClock={true}
											readOnly
											/>
										</div>
									</div>
								</div>
							</div>
						}

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Órgão:</label>
										<SelectSearch
											id="orgao"
											name="orgao"
											options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
											includeAllOption={true}
											allOptionName="Todos"
											onChange={this.handleOrgaoChange}
											value={orgao}
											isLoading={carregandoOrgaos}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Gestor:</label>
										<SelectSearch
											id="gestor"
											name="gestor"
											options={this.state.gestores.map(gestor => ({ value: gestor.cpf, label: gestor.nome }))}
											includeAllOption={true}
											allOptionName="Todos"
											onChange={this.handleInputChange}
											value={gestor}
											isLoading={carregandoGestores}
										/>
									</div>
								</div>
							</div>
							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Situação:</label>
										<SelectSearch
											id="lidas"
											name="lidas"
											options={[{ value: true, label: 'Lidas' }, { value: false, label: 'Não lidas' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={lidas}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Órgão</th>
												<th scope="col">Gestor</th>
												<th scope="col">Atribuição</th>
												<th scope="col">Lida</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((mensagem, index) =>
													<tr key={index} >
														<td>{mensagem.nomeOrgao}</td>
														<td>{mensagem.nomeGestor}</td>
														<td>{mensagem.nomeAtribuicaoGestor ? mensagem.nomeAtribuicaoGestor : ''}</td>
														<td>{mensagem.lida ? 'Sim' : 'Não'}</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhuma mensagem encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));
		}

		handleOrgaoChange(evento){
			const valor = evento.target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa['orgao'] = valor;
			criterioPesquisa['gestor'] = '';
			this.setState((prevState) => ({ ...prevState,  criterioPesquisa }));
			this.carregarGestores(this.state.criterioPesquisa.solicitacao, valor);
		}

		executarPesquisaAnterior(state) {
			const lastState = state ?? this.props.filters[this.props.location.pathname];

			this.setState((prevState) => ({ ...prevState, 
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const previousPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(previousPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/mensagem-gestor/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState((prevState) => (
					{ ...prevState, 
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as mensagens. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();

			const solicitacao = this.state.criterioPesquisa.solicitacao;
			this.setState((prevState) => (
				{ ...prevState, 
					criterioPesquisa: {
						solicitacao,
						orgao: '',
						gestor: '',
						lidas: '',
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					exibeModalConfirmacao: false,
					botoesHabilitados : true,
				}), () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/solicitacao-comunicacao/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState((prevState) => ({ ...prevState, botoesHabilitados : false}));

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioSolicitacoesComunicacao.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de solicitações de comunicação';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState((prevState) => ({ ...prevState, botoesHabilitados : true}));
				});
		}
		
	}

) // redux
); // router